import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { Environment } from '~/types/EnvironmentTypes'
import { buildEnvironment } from '~/utils/common'

import { useContactsDetailViewStyle } from './componentStyles/ContactsDetailView.style'
import { ContactEventHistory } from './ContactEventHistory'
import { ContactItems } from './ContactItems'
import {
  ContactDetails,
  ContactHistory,
  ContactNumber,
} from './viewModels/Contacts.viewmodel'

//TODO: Remove this when the feature is ready for production
const shouldShowHistoryView = buildEnvironment === Environment.LOCAL
interface DetailViewHeaderProps {
  contactName: string
  gender?: string
  age?: number
}
export const DetailViewHeader = ({
  contactName,
  gender,
  age,
}: DetailViewHeaderProps) => {
  return (
    <Flex direction="column" pl="1rem">
      <Text textStyle="H5">{contactName}</Text>
      {gender && age && (
        <Text
          textStyle="Body2"
          color="gray.800"
        >{`Age: ${age}, ${gender}`}</Text>
      )}
    </Flex>
  )
}

interface ContactsDetailViewProps {
  contactDetails: ContactDetails
  searchTerm?: string
  contactHistory: ContactHistory[]
  onCallClick: (callee: {
    contactNumber: ContactNumber
    contact: ContactDetails
  }) => void
  onMessagingClick: (number: string) => void
  onFaxClick: (number: string) => void
  onCopyClick: (number: string) => void
}
export const ContactsDetailView = ({
  contactDetails,
  searchTerm,
  contactHistory,
  onCallClick,
  onMessagingClick,
  onFaxClick,
  onCopyClick,
}: ContactsDetailViewProps) => {
  const style = useContactsDetailViewStyle()
  return (
    <Flex sx={style} className="scrollbar-hidden">
      <ContactItems
        contactDetails={contactDetails}
        searchTerm={searchTerm}
        onCallClick={onCallClick}
        onMessagingClick={onMessagingClick}
        onFaxClick={onFaxClick}
        onCopyClick={onCopyClick}
      />
      {shouldShowHistoryView && (
        <ContactEventHistory contactHistory={contactHistory} />
      )}
    </Flex>
  )
}
